import React, { useMemo } from "react";
import { useState } from "react";
import { Layout, Tabs } from "antd";
import "../Courses&Planification/CoursesAndPlanification.css";
import EventList from "../../Events/components/EventList/EventList";
import EventRequest from "../../EventRequest/EventRequest";

const EventsAndRequests = () => {
  const [name, setName] = useState("Events");

  const onChangeHeaderName = (key) => {
    switch (key) {
      case "1":
        setName("Events");
        break;
      case "2":
        setName("Requests");
        break;
      default:
        setName("Events");
    }
  };

  const items = useMemo(
    () => [
      {
        key: "1",
        label: `Events`,
        children: <EventList nameSection="Event" includeUpcoming={false}/>,
      },
      {
        key: "2",
        label: `Requests`,
        children: <EventRequest nameSection="EventRequests" />,
      },
    ],
    []
  );
  return (
    <Layout pagename={name}>
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={onChangeHeaderName}
        className="custom-tabs"
        destroyInactiveTabPane={true}
      />
    </Layout>
  );
};

export default EventsAndRequests;
